<template>
    <div class="homework-view-container">
        <TopBar v-if="user" :user="user" :apps="apps" />
        <div class="homework-header">
            <h1>我的作业</h1>
            <p>查看和管理您的作业任务</p>
            <button @click="goToFutureEngine" class="btn btn-secondary return-btn">我的技能树</button>

            <!-- 管理员用户选择器 -->
            <div v-if="user && user.userType === 1" class="user-selector">
                <input v-model="userSearchText" placeholder="选择用户查看作业" class="search-input" @focus="showUserList = true"
                    @blur="hideUserList" />
                <div v-if="showUserList" class="users-list">
                    <div v-for="userItem in filteredUsers" :key="userItem.id" class="user-item"
                        @click="selectUser(userItem)">
                        {{ userItem.username || userItem.nickname || `用户${userItem.id}` }} ({{ userItem.nickname ||
                            userItem.username || `用户${userItem.id}` }})
                    </div>
                </div>
            </div>
        </div>

        <div class="homework-content">
            <div v-if="loading" class="loading">
                <div class="spinner"></div>
                <p>加载中...</p>
            </div>

            <div v-else-if="homeworkGroups.length === 0" class="empty-state">
                <div class="empty-icon">📝</div>
                <h3>暂无作业</h3>
                <p>您当前没有待完成的作业</p>
            </div>

            <div v-else class="homework-list">
                <div v-for="group in homeworkGroups" :key="group.date" class="date-group">
                    <div class="date-header">
                        <h2>{{ formatDate(group.date) }}</h2>
                        <span class="assignment-count">{{ group.assignments.length }} 项作业</span>
                    </div>

                    <div v-for="assignment in group.assignments" :key="assignment.id" class="assignment-card">
                        <div class="assignment-header">
                            <h3>{{ assignment.node.name }}</h3>
                            <!-- <div class="assignment-status" :class="getStatusClass(assignment.status)">
                                {{ getStatusText(assignment.status) }}
                            </div> -->
                        </div>

                        <div class="assignment-content">
                            <div class="questions-list">
                                <div v-for="question in assignment.questions" :key="question.id" class="question-item">
                                    <div class="question-info">
                                        <div class="question-header">
                                            <div class="question-title-and-link">
                                                <span class="question-name">{{ question.name }}</span>
                                                <button v-if="parseNodeDesc(question.desc).link"
                                                    @click="openLink(parseNodeDesc(question.desc).link)"
                                                    class="btn btn-link">
                                                    前往练习
                                                </button>
                                                <button v-if="!question.completed"
                                                    @click="markAsCompleted(assignment.id, question.id)"
                                                    class="btn btn-primary">
                                                    标记为已提交
                                                </button>
                                                <button v-else class="btn btn-success" disabled>
                                                    已提交
                                                </button>
                                                <!-- 管理员评价按钮 -->
                                                <button v-if="user && user.userType === 1"
                                                    @click="showRatingDialog(question)" class="btn btn-secondary">
                                                    评价
                                                </button>
                                            </div>
                                            <div class="question-actions">

                                            </div>
                                        </div>
                                        <hr class="divider">
                                        <div v-if="question.stars !== undefined && question.stars !== null"
                                            class="stars-display" :key="`stars-${question.id}-${question.stars}`">
                                            <strong>完成等级:</strong>
                                            <span v-for="star in 5" :key="`star-${question.id}-${star}`" class="star"
                                                :class="{ 'star-filled': star <= question.stars }">
                                                {{ star <= question.stars ? '★' : '☆' }} </span>
                                                    <span class="star-text">({{ question.stars }}/5)</span>
                                        </div>

                                    </div>

                                    <div v-if="question.teacherComment" class="teacher-comment">
                                        <strong>老师评价:</strong>
                                        <p>{{ question.teacherComment }}</p>
                                    </div>

                                    <div v-if="question.remark" class="remark">
                                        <strong>评语:</strong>
                                        <p>{{ question.remark }}</p>
                                    </div>

                                    <div class="result-status">
                                        <strong>状态:</strong>
                                        <span :class="question.result ? 'status-completed' : 'status-pending'">
                                            {{ question.result ? '已完成' : '待完成' }}
                                        </span>
                                    </div>


                                </div>
                            </div>

                            <!-- <div class="assignment-actions">
                                <button v-if="assignment.status !== 'submitted'"
                                    @click="submitAssignment(assignment.id)" class="btn btn-submit"
                                    :disabled="!canSubmit(assignment)">
                                    提交作业
                                </button>
                                <button v-else class="btn btn-submitted" disabled>
                                    已提交
                                </button>
                            </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 评价模态框 -->
    <div v-if="showRatingModal" class="rating-modal-overlay" @click="closeRatingModal">
        <div class="rating-modal" @click.stop>
            <div class="rating-modal-header">
                <h3>评价作业</h3>
                <button class="close-btn" @click="closeRatingModal">×</button>
            </div>
            <div class="rating-modal-body">
                <div class="rating-item">
                    <label>题目:</label>
                    <span>{{ currentQuestionForRating ? currentQuestionForRating.name : '' }}</span>
                </div>
                <div class="rating-item">
                    <label>完成等级:</label>
                    <div class="star-rating">
                        <span v-for="i in 5" :key="i" class="star" :class="{ 'star-filled': i <= ratingStars }"
                            @click="setRatingStars(i)">
                            ★
                        </span>
                        <span class="star-count">({{ ratingStars }}/5)</span>
                    </div>
                </div>
                <div class="rating-item">
                    <label>完成状态:</label>
                    <label class="checkbox-label">
                        <input type="checkbox" v-model="ratingResult" />
                        已完成
                    </label>
                </div>
                <div class="rating-item">
                    <label>评语:</label>
                    <textarea v-model="ratingRemark" placeholder="请输入评语..." rows="4"></textarea>
                </div>
            </div>
            <div class="rating-modal-footer">
                <button @click="saveRating" class="btn btn-primary">保存评价</button>
                <button @click="closeRatingModal" class="btn btn-secondary">取消</button>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, computed } from 'vue';
import TopBar from '@/components/TopBar.vue';
import graphService from '@/services/graphService';
import AuthService from '@/services/authService';

export default {
    name: 'HomeworkView',
    components: {
        TopBar
    },
    setup() {
        const loading = ref(true);
        const homeworkGroups = ref([]);
        const user = ref(null);
        const apps = ref([]);

        // 用户选择相关数据
        const userSearchText = ref('');
        const allUsers = ref([]);
        const showUserList = ref(false);
        const selectedUserForHomework = ref(null);

        // 评价相关数据
        const showRatingModal = ref(false);
        const currentQuestionForRating = ref(null);
        const ratingStars = ref(0);
        const ratingRemark = ref('');
        const ratingResult = ref(false);

        // 获取当前用户信息
        const getCurrentUser = () => {
            const currentUser = AuthService.getCurrentUser();
            console.log('从AuthService获取的用户信息:', currentUser);
            if (currentUser) {
                user.value = {
                    id: currentUser.userid || currentUser.id || 1,
                    name: currentUser.nickname || currentUser.username || '用户名',
                    avatar: currentUser.icon || currentUser.avatar || require('@/assets/logo.png'),
                    userType: currentUser.userType || currentUser.user_type || 10
                };
            } else {
                // 如果没有用户信息，使用默认值
                user.value = {
                    id: 1,
                    name: '用户名',
                    avatar: require('@/assets/logo.png'),
                    userType: 10
                };
            }
            console.log('处理后的用户信息:', user.value);
            return user.value;
        };

        // 加载应用信息
        const loadAppInfo = async () => {
            try {
                // 导入UserMainService
                const UserMainService = (await import('@/services/userMainService.js')).default;
                console.log('用户类型:', user.value.userType);
                const response = await UserMainService.getAllApps(user.value.userType || 10);
                if (response.status === 200 && response.apps) {
                    apps.value = response.apps.map(app => ({
                        id: app.id,
                        name: app.name,
                        desc: app.desc,
                        link: app.name === '未来引擎' ? '/futureengine' : app.link,
                        icon: app.icon || 'code',
                        used: app.used || false
                    }));
                }
            } catch (error) {
                console.error('获取应用数据失败:', error);
                apps.value = [
                    { id: 1, name: 'OJ练习', desc: '在线编程练习', link: '/CppOJ/', icon: 'code', used: true },
                    { id: 2, name: '任务清单', desc: '待办事项管理', link: '/todo', icon: 'list', used: true },
                    { id: 3, name: '时间线', desc: '时间记录管理', link: '/TimeLine/', icon: 'timeline', used: false },
                    { id: 4, name: '知识图谱', desc: '知识关系展示', link: '/graph', icon: 'share', used: false },
                    { id: 5, name: '快速抢答', desc: '抢答与记忆训练', link: '/abhs', icon: 'quiz', used: false },
                    { id: 6, name: '文件管理', desc: '文件上传下载', link: '/FileManage/', icon: 'folder', used: false },
                    { id: 7, name: '数据可视化', desc: '数据图表展示', link: '/DataVisual/', icon: 'bar_chart', used: false }
                ];
            }
        };

        // 格式化日期显示
        const formatDate = (dateString) => {
            const today = new Date();
            const date = new Date(dateString);

            // 如果是今天
            if (date.toDateString() === today.toDateString()) {
                return '今天';
            }

            // 如果是昨天
            const yesterday = new Date(today);
            yesterday.setDate(yesterday.getDate() - 1);
            if (date.toDateString() === yesterday.toDateString()) {
                return '昨天';
            }

            // 如果是本周
            const weekAgo = new Date(today);
            weekAgo.setDate(weekAgo.getDate() - 7);
            if (date >= weekAgo) {
                const weekdays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
                return weekdays[date.getDay()];
            }

            // 其他情况显示具体日期
            return `${date.getMonth() + 1}月${date.getDate()}日`;
        };

        // 获取状态文本
        const getStatusText = (status) => {
            const statusMap = {
                'pending': '待完成',
                'in_progress': '进行中',
                'completed': '已完成',
                'submitted': '已提交'
            };
            return statusMap[status] || '待完成';
        };

        // 获取状态样式类
        const getStatusClass = (status) => {
            return `status-${status}`;
        };

        // 解析节点描述中的link属性
        const parseNodeDesc = (desc) => {
            if (!desc) return {};

            // 如果desc已经是对象，直接返回
            if (typeof desc === 'object' && desc !== null) {
                return desc;
            }

            // 如果desc是字符串，尝试解析为JSON
            if (typeof desc === 'string') {
                try {
                    return JSON.parse(desc);
                } catch (e) {
                    console.warn('Failed to parse node description:', e);
                    return {};
                }
            }

            return {};
        };

        // 打开链接
        const openLink = (url) => {
            if (url) {
                window.open(url, '_blank');
            }
        };

        // 判断是否可以提交作业
        const canSubmit = (assignment) => {
            return assignment.questions.some(q => q.completed);
        };

        // 标记题目为已完成
        const markAsCompleted = async (assignmentId, questionId) => {
            const group = homeworkGroups.value.find(g =>
                g.assignments.some(a => a.id === assignmentId)
            );

            if (group) {
                const assignment = group.assignments.find(a => a.id === assignmentId);
                if (assignment) {
                    const question = assignment.questions.find(q => q.id === questionId);
                    if (question) {
                        // 更新题目状态
                        question.completed = true;
                        question.result = true; // 同时更新result参数

                        // 更新作业描述中的completed状态
                        let updatedDesc;
                        if (typeof question.desc === 'string') {
                            try {
                                // 尝试解析现有的desc字符串
                                const descObj = JSON.parse(question.desc);
                                descObj.completed = true;
                                updatedDesc = JSON.stringify(descObj);
                                question.desc = updatedDesc;
                            } catch (e) {
                                // 如果无法解析，检查是否已经有completed字段
                                if (question.desc.includes('completed')) {
                                    // 替换completed字段的值
                                    updatedDesc = question.desc.replace(/"completed"\s*:\s*(true|false)/, '"completed":true');
                                    question.desc = updatedDesc;
                                } else {
                                    // 如果没有completed字段，添加它
                                    if (question.desc.trim().endsWith('}')) {
                                        // 如果是以}结尾的JSON对象
                                        updatedDesc = question.desc.trim().slice(0, -1) + ',"completed":true}';
                                        question.desc = updatedDesc;
                                    } else {
                                        // 创建新的描述对象
                                        updatedDesc = JSON.stringify({ completed: true });
                                        question.desc = updatedDesc;
                                    }
                                }
                            }
                        } else if (typeof question.desc === 'object' && question.desc !== null) {
                            question.desc.completed = true;
                            updatedDesc = JSON.stringify(question.desc);
                        } else {
                            // 如果desc为空或其他类型，创建新的描述对象
                            updatedDesc = JSON.stringify({ completed: true });
                            question.desc = updatedDesc;
                        }

                        // 调用API更新作业状态
                        try {
                            const response = await graphService.updateHomeworkStatus(question.relationId, updatedDesc);
                            if (response.status === 200) {
                                console.log('作业状态更新成功');
                            } else {
                                console.error('作业状态更新失败:', response.message);
                            }
                        } catch (error) {
                            console.error('更新作业状态时发生错误:', error);
                        }
                    }
                }
            }
        };

        // 提交作业
        const submitAssignment = (assignmentId) => {
            const group = homeworkGroups.value.find(g =>
                g.assignments.some(a => a.id === assignmentId)
            );

            if (group) {
                const assignment = group.assignments.find(a => a.id === assignmentId);
                if (assignment) {
                    assignment.status = 'submitted';
                    // 这里可以调用API提交作业
                    console.log('提交作业:', assignment);
                }
            }
        };

        // 返回到futureEngine页面
        const goToFutureEngine = () => {
            window.location.href = '/futureengine';
        };

        // 加载所有用户数据
        const loadAllUsers = async () => {
            try {
                // 调用后端API获取所有用户数据
                const response = await graphService.getAllUsers();
                console.log('获取所有用户数据:', response);
                if (response && Array.isArray(response)) {
                    allUsers.value = response.map(user => ({
                        id: user.id,
                        username: user.username || user.nickname || user.name || `用户${user.id}`,  // 使用username或nickname或name作为username显示
                        nickname: user.nickname || user.username || user.name || `用户${user.id}`
                    }));
                } else {
                    // 如果没有获取到数据，使用模拟数据
                    allUsers.value = [
                        { id: 1, username: 'admin', nickname: '管理员' },
                        { id: 2, username: 'user1', nickname: '用户1' },
                        { id: 3, username: 'user2', nickname: '用户2' }
                    ];
                }
            } catch (error) {
                console.error('加载用户数据失败:', error);
                // 出错时使用模拟数据
                allUsers.value = [
                    { id: 1, username: 'admin', nickname: '管理员' },
                    { id: 2, username: 'user1', nickname: '用户1' },
                    { id: 3, username: 'user2', nickname: '用户2' }
                ];
            }
        };

        // 过滤用户
        const filteredUsers = computed(() => {
            if (!userSearchText.value) {
                return allUsers.value;
            }
            return allUsers.value.filter(userItem =>
                userItem.username.toLowerCase().includes(userSearchText.value.toLowerCase()) ||
                userItem.nickname.toLowerCase().includes(userSearchText.value.toLowerCase())
            );
        });

        // 选择用户
        const selectUser = (userItem) => {
            selectedUserForHomework.value = userItem;
            userSearchText.value = `${userItem.username || userItem.nickname || `用户${userItem.id}`} (${userItem.nickname || userItem.username || `用户${userItem.id}`})`;
            showUserList.value = false;

            // 重新加载作业数据
            loadHomeworkDataForUser(userItem.id);
        };

        // 隐藏用户列表
        const hideUserList = () => {
            // 延迟隐藏，以便点击事件能够触发
            setTimeout(() => {
                showUserList.value = false;
            }, 200);
        };

        // 加载指定用户的作业数据
        const loadHomeworkDataForUser = async (userId) => {
            try {
                loading.value = true;

                // 调用API获取指定用户的数据
                const response = await graphService.getMyHomeworks(userId);
                if (response.status === 200) {
                    homeworkGroups.value = response.data;
                }
            } catch (error) {
                console.error('加载指定用户作业数据失败:', error);

                // 出错时使用模拟数据
                homeworkGroups.value = [
                    {
                        date: new Date().toISOString().split('T')[0],
                        assignments: [
                            {
                                id: 1,
                                node: { id: 101, name: 'GESP一级练习' },
                                status: 'in_progress',
                                questions: [
                                    {
                                        id: 1001,
                                        relationId: 101,
                                        name: '变量与数据类型',
                                        desc: '{"link":"https://example.com/practice/variables"}',
                                        stars: 4,
                                        teacherComment: '回答得很好，注意变量命名规范',
                                        remark: '完成的不错',
                                        result: true,
                                        completed: true
                                    }
                                ]
                            }
                        ]
                    }
                ];
            } finally {
                loading.value = false;
            }
        };

        // 显示评价模态框
        const showRatingDialog = (question) => {
            currentQuestionForRating.value = question;
            ratingStars.value = question.stars || 0;
            ratingRemark.value = question.remark || '';
            ratingResult.value = question.result || false;
            showRatingModal.value = true;
        };

        // 保存评价
        const saveRating = async () => {
            if (!currentQuestionForRating.value || !selectedUserForHomework.value) {
                console.error('没有选择要评价的题目或用户');
                return;
            }

            try {
                // 更新当前题目的评价信息
                currentQuestionForRating.value.stars = ratingStars.value;
                currentQuestionForRating.value.remark = ratingRemark.value;
                currentQuestionForRating.value.result = ratingResult.value;

                // 使用updateHomeworkStatus方法更新作业状态，而不是addStatistics
                // 因为addStatistics会创建当天日期节点，而作业系统使用的是作业布置的日期节点
                if (currentQuestionForRating.value.relationId) {
                    const desc = JSON.stringify({
                        stars: ratingStars.value,
                        remark: ratingRemark.value,
                        result: ratingResult.value,
                        completed: currentQuestionForRating.value.completed || true
                    });

                    const response = await graphService.updateHomeworkStatus(
                        currentQuestionForRating.value.relationId,
                        desc
                    );

                    if (response.status === 200) {
                        console.log('评价保存成功');
                        // 更新本地数据
                        currentQuestionForRating.value.teacherComment = ratingRemark.value;

                        // 关闭模态框
                        showRatingModal.value = false;

                        // 重新加载作业数据以显示最新评价
                        await loadHomeworkDataForUser(selectedUserForHomework.value.id);
                    } else {
                        console.error('评价保存失败:', response.message);
                    }
                }
            } catch (error) {
                console.error('保存评价时出错:', error);
            }
        };

        // 设置星级
        const setRatingStars = (starCount) => {
            ratingStars.value = starCount;
        };

        // 关闭评价模态框
        const closeRatingModal = () => {
            showRatingModal.value = false;
        };

        // 加载作业数据
        const loadHomeworkData = async () => {
            try {
                loading.value = true;
                const currentUser = getCurrentUser();

                if (!currentUser) {
                    throw new Error('无法获取用户信息');
                }

                // 如果是管理员且选择了特定用户，则加载该用户的作业，否则加载当前用户的作业
                let userIdToLoad = currentUser.id;
                if (user.value && user.value.userType === 1 && selectedUserForHomework.value) {
                    userIdToLoad = selectedUserForHomework.value.id;
                }

                // 调用API获取数据
                const response = await graphService.getMyHomeworks(userIdToLoad);
                if (response.status === 200) {
                    homeworkGroups.value = response.data;
                }
            } catch (error) {
                console.error('加载作业数据失败:', error);

                // 出错时使用模拟数据
                homeworkGroups.value = [
                    {
                        date: new Date().toISOString().split('T')[0],
                        assignments: [
                            {
                                id: 1,
                                node: { id: 101, name: 'GESP一级练习' },
                                status: 'in_progress',
                                questions: [
                                    {
                                        id: 1001,
                                        relationId: 101,
                                        name: '变量与数据类型',
                                        desc: '{"link":"https://example.com/practice/variables"}',
                                        stars: 4,
                                        teacherComment: '回答得很好，注意变量命名规范',
                                        remark: '完成的不错',
                                        result: true,
                                        completed: true
                                    },
                                    {
                                        id: 1002,
                                        relationId: 102,
                                        name: '运算符使用',
                                        desc: '{"link":"https://example.com/practice/operators"}',
                                        stars: 3,
                                        teacherComment: '基本正确，但需要加强逻辑运算符的理解',
                                        remark: '需要加强练习',
                                        result: false,
                                        completed: false
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        date: new Date(Date.now() - 86400000).toISOString().split('T')[0], // 昨天
                        assignments: [
                            {
                                id: 2,
                                node: { id: 102, name: 'GESP二级练习' },
                                status: 'pending',
                                questions: [
                                    {
                                        id: 2001,
                                        relationId: 103,
                                        name: '循环结构',
                                        desc: '{"link":"https://example.com/practice/loops"}',
                                        stars: 0,
                                        teacherComment: '',
                                        remark: '',
                                        result: false,
                                        completed: false
                                    },
                                    {
                                        id: 2002,
                                        relationId: 104,
                                        name: '数组操作',
                                        desc: '{"link":"https://example.com/practice/arrays"}',
                                        stars: 0,
                                        teacherComment: '',
                                        remark: '',
                                        result: false,
                                        completed: false
                                    }
                                ]
                            }
                        ]
                    }
                ];
            } finally {
                loading.value = false;
            }
        };

        // 组件挂载时加载数据
        onMounted(async () => {
            try {
                getCurrentUser();
                await loadAppInfo();

                // 如果是管理员用户，加载所有用户数据
                if (user.value && user.value.userType === 1) {
                    await loadAllUsers();
                }

                loadHomeworkData();
            } catch (error) {
                console.error('组件初始化失败:', error);
                // 即使初始化失败，也要确保有默认的用户信息
                if (!user.value) {
                    user.value = {
                        id: 1,
                        name: '用户名',
                        avatar: require('@/assets/logo.png'),
                        userType: 10
                    };
                }
            }
        });

        return {
            loading,
            homeworkGroups,
            user,
            apps,
            formatDate,
            getStatusText,
            getStatusClass,
            canSubmit,
            markAsCompleted,
            submitAssignment,
            parseNodeDesc,
            openLink,
            goToFutureEngine,
            userSearchText,
            filteredUsers,
            showUserList,
            selectUser,
            hideUserList,
            // 评价相关
            showRatingModal,
            currentQuestionForRating,
            ratingStars,
            ratingRemark,
            ratingResult,
            showRatingDialog,
            saveRating,
            setRatingStars,
            closeRatingModal
        };
    }
};
</script>

<style scoped>
.homework-view-container {
    min-height: 100vh;
    background-color: #f5f7fa;
    padding-bottom: 20px;
}

.homework-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 20px;
    text-align: center;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.homework-header h1 {
    margin: 0 0 10px 0;
    font-size: 2rem;
    font-weight: 600;
}

.homework-header p {
    margin: 0;
    font-size: 1rem;
    opacity: 0.9;
}

.user-selector {
    position: relative;
    margin-top: 15px;
    display: inline-block;
    width: 300px;
}

.user-selector .search-input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.9rem;
    background: white;
}

.user-selector .search-input:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

.users-list {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background: white;
    border: 1px solid #ccc;
    border-top: none;
    border-radius: 0 0 4px 4px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    color: #333;
    /* 确保文字颜色可见 */
}

.user-item {
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid #eee;
    transition: background-color 0.2s;
    color: #333;
    /* 确保文字颜色可见 */
}

.user-item:hover {
    background-color: #f5f7fa;
}

.user-item:last-child {
    border-bottom: none;
}

.return-btn {
    margin-top: 15px;
    padding: 8px 16px;
    font-size: 0.9rem;
}

/* 评价模态框样式 */
.rating-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.rating-modal {
    background: white;
    border-radius: 8px;
    width: 500px;
    max-width: 90vw;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.rating-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #eee;
}

.rating-modal-header h3 {
    margin: 0;
    font-size: 1.2rem;
    color: #333;
}

.close-btn {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #999;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.close-btn:hover {
    color: #666;
}

.rating-modal-body {
    padding: 20px;
}

.rating-item {
    margin-bottom: 15px;
}

.rating-item label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
    color: #333;
}

.star-rating {
    display: flex;
    align-items: center;
}

.star {
    font-size: 1.5rem;
    color: #ddd;
    cursor: pointer;
    margin-right: 5px;
}

.star:hover,
.star-filled {
    color: #f1c40f;
}

.star-count {
    margin-left: 10px;
    color: #666;
}

.checkbox-label {
    display: flex;
    align-items: center;
    cursor: pointer;
}

.checkbox-label input {
    margin-right: 8px;
}

.rating-modal-body textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    resize: vertical;
    font-family: inherit;
    font-size: 1rem;
}

.rating-modal-body textarea:focus {
    outline: none;
    border-color: #667eea;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

.rating-modal-footer {
    padding: 15px 20px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
}

.rating-modal-footer .btn {
    min-width: 80px;
}

.homework-content {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
}

.loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
}

.spinner {
    width: 40px;
    height: 40px;
    border: 4px solid rgba(0, 0, 0, 0.1);
    border-left-color: #667eea;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 15px;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.empty-state {
    text-align: center;
    padding: 60px 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.empty-icon {
    font-size: 3rem;
    margin-bottom: 20px;
}

.empty-state h3 {
    margin: 0 0 10px 0;
    color: #333;
}

.empty-state p {
    color: #666;
    margin: 0;
}

.date-group {
    margin-bottom: 30px;
}

.date-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    padding: 15px 20px;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
    margin-bottom: 15px;
}

.date-header h2 {
    margin: 0;
    font-size: 1.4rem;
    color: #333;
}

.assignment-count {
    background: #667eea;
    color: white;
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 0.9rem;
}

.assignment-card {
    background: white;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;
    overflow: hidden;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.assignment-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.assignment-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #eee;
}

.assignment-header h3 {
    margin: 0;
    font-size: 1.2rem;
    color: #333;
}

.assignment-status {
    padding: 5px 12px;
    border-radius: 20px;
    font-size: 0.85rem;
    font-weight: 500;
}

.status-pending {
    background: #ffeaa7;
    color: #d35400;
}

.status-in_progress {
    background: #74b9ff;
    color: white;
}

.status-completed {
    background: #00b894;
    color: white;
}

.status-submitted {
    background: #6c5ce7;
    color: white;
}

.assignment-content {
    padding: 20px;
}

.questions-list {
    margin-bottom: 20px;
}

.question-item {
    padding: 15px;
    border: 1px solid #eee;
    border-radius: 8px;
    margin-bottom: 15px;
    background: #fafafa;
}

.question-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
}

.question-name {
    font-weight: 500;
    color: #333;
}

.stars-display {
    display: flex;
    align-items: center;
    gap: 2px;
}

.star {
    font-size: 0.9rem;
    margin-right: 2px;
}

/* 为实心星星添加金黄色 */
.question-item .stars-display .star-filled {
    color: #f1c40f;
    /* 金黄色 */
}

.star-text {
    margin-left: 5px;
    font-size: 0.9rem;
    color: #666;
}

.teacher-comment {
    background: #e8f4fc;
    padding: 10px;
    border-radius: 5px;
    margin: 10px 0;
    font-size: 0.9rem;
}

.teacher-comment strong {
    color: #333;
}

.teacher-comment p {
    margin: 5px 0 0 0;
    color: #555;
}

.question-actions {
    margin-top: 10px;
    display: flex;
    align-items: center;
    gap: 10px;
}

.question-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.question-name {
    flex: 1;
    font-weight: 500;
    color: #333;
}

.question-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 10px;
}

.question-title-and-link {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    gap: 10px;
}

.btn {
    padding: 8px 16px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s ease;
}

.btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.btn-primary {
    background: #667eea;
    color: white;
}

.btn-primary:hover:not(:disabled) {
    background: #5a6fd8;
}

.btn-success {
    background: #00b894;
    color: white;
}

.btn-secondary {
    background: #6c757d;
    color: white;
}

.btn-secondary:hover:not(:disabled) {
    background: #5a6268;
}

.btn-submit {
    background: #0984e3;
    color: white;
    padding: 10px 20px;
}

.btn-submit:hover:not(:disabled) {
    background: #0770c4;
}

.btn-submitted {
    background: #6c5ce7;
    color: white;
    padding: 10px 20px;
}

.btn-link {
    background: #fdcb6e;
    color: #2d3436;
    padding: 8px 16px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s ease;
}

.btn-link:hover:not(:disabled) {
    background: #e17055;
    color: white;
}

.remark {
    background: #e8f4fc;
    padding: 10px;
    border-radius: 5px;
    margin: 10px 0;
    font-size: 0.9rem;
}

.remark strong {
    color: #333;
}

.remark p {
    margin: 5px 0 0 0;
    color: #555;
}

.result-status {
    margin: 10px 0;
    padding: 8px;
    border-radius: 4px;
    font-weight: 500;
}

.result-status strong {
    margin-right: 8px;
}

.status-completed {
    color: #00b894;
    background-color: #e8f7f4;
    padding: 4px 8px;
    border-radius: 4px;
}

.status-pending {
    color: #e17055;
    background-color: #fdf0eb;
    padding: 4px 8px;
    border-radius: 4px;
}

.divider {
    border: none;
    height: 1px;
    background: linear-gradient(to right, transparent, #ccc, transparent);
    margin: 15px 0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

/* 响应式设计 */
@media (max-width: 768px) {
    .homework-header h1 {
        font-size: 1.5rem;
    }

    .homework-content {
        padding: 10px;
    }

    .return-btn {
        width: 100%;
        margin-top: 15px;
    }

    .date-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .date-header h2 {
        font-size: 1.2rem;
    }

    .assignment-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .question-info {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
    }

    .question-header {
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
    }

    .question-name {
        width: 100%;
    }

    .question-title-and-link {
        width: 100%;
        flex-direction: column;
        align-items: flex-start;
    }

    .stars-display {
        margin-top: 5px;
    }

    .btn-link {
        margin-left: 0;
        margin-top: 5px;
    }

    .question-title-and-link .btn-link {
        align-self: flex-end;
    }

    .question-actions {
        width: 100%;
        justify-content: flex-end;
    }

    .remark {
        margin: 10px 0;
        padding: 8px;
    }

    .result-status {
        margin: 10px 0;
        padding: 6px;
    }
}

@media (max-width: 480px) {
    .homework-header {
        padding: 15px 10px;
    }

    .date-header,
    .assignment-header,
    .assignment-content {
        padding: 15px;
    }

    .question-item {
        padding: 12px;
    }
}
</style>